module.exports = __webpack_public_path__ + "img/pasture_cynodon_low.e6025614.webp";